<template>
  <div id="main-page">
    <header-comp @nav-click="onNavClick" />

    <main-sing-up
      v-if="signMain"
      @sign-close="signMain = false; signMainData.title = ''"
      :title="signMainData.title"
    />
    <sing-up-subscription
      v-if="signUpSubscription.show"
      :sub-type="signUpSubscription.subType"
      @sign-close="signUpSubscription.show = false"
    />
    <sing-up-offers
      v-if="signUpOffers.show"
      :offType="signUpOffers.offType"
      @sign-close="signUpOffers.show = false"
    />
    <sing-up-certificate
      v-if="signUpCertificate.show"
      :cert-type="signUpCertificate.certType"
      @sign-close="signUpCertificate.show = false"
    />
    <div class="main-root">
      <div class="main-root__item level_1">
        <img src="../assets/images/level_1.png" alt="" />
      </div>
      <div id="scroll-main-describe" class="main-root__item level_2">
        <main-describe />
      </div>
      <div id="scroll-master-class" class="main-root__item level_3">
        <master-class @purchase="(title: string) => {signMainData.title = title; signMain = true}" />
      </div>
      <div class="main-root__item level_4">
        <subscriptions @purchase="(subType: string) => {signUpSubscription.subType = subType; signUpSubscription.show = true}" />
      </div>
      <div class="main-root__item level_4">
        <courses @purchase="(title: string) => {signMainData.title = title; signMain = true}"/>
      </div>
      <div class="main-root__item level_5">
        <img src="../assets/images/level_5.jpeg" alt="" />
      </div>
      <div class="main-root__item level_6">
        <certificates @purchase="(certType: string) => {signUpCertificate.certType = certType; signUpCertificate.show = true}" />
      </div>
      <div class="main-root__item level_7">
        <offers @purchase="(offType: string) => {signUpOffers.offType = offType; signUpOffers.show = true}"  />
      </div>
      <div id="scroll-student-works" class="main-root__item level_8">
        <student-works />
      </div>
      <div class="main-root__item level_9">
        <teacher-works />
      </div>
      <div id="scroll-address" class="main-root__item level_10">
        <address-info />
      </div>
      <div class="main-root__item contact_info">
        <contact-info />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { defineAsyncComponent } from "vue";
import Header from "@/components/HeaderTop.vue";

export default defineComponent({
  components: {
    "header-comp": Header,
    "main-describe": defineAsyncComponent(
      () => import("@/components/MainDescribe.vue"),
    ),
    "master-class": defineAsyncComponent(
      () => import("@/components/MasterClasses/MasterRoot.vue"),
    ),
    subscriptions: defineAsyncComponent(
      () => import("@/components/Subscription/SubscriptionRoot.vue"),
    ),
    courses: defineAsyncComponent(
        () => import("@/components/Courses/CourseRoot.vue"),
    ),
    certificates: defineAsyncComponent(
      () => import("@/components/Certificates/CertificatesRoot.vue"),
    ),
    offers: defineAsyncComponent(
      () => import("@/components/Offers/OffersRoot.vue"),
    ),
    "student-works": defineAsyncComponent(
      () => import("@/components/StudentsWorks.vue"),
    ),
    "teacher-works": defineAsyncComponent(
      () => import("@/components/TeacherWorks.vue"),
    ),
    "address-info": defineAsyncComponent(
      () => import("@/components/AddressInfo.vue"),
    ),
    "contact-info": defineAsyncComponent(
      () => import("@/components/ContactInfo.vue"),
    ),
    "main-sing-up": defineAsyncComponent(
      () => import("@/components/MainSignUp.vue"),
    ),
    "sing-up-subscription": defineAsyncComponent(
      () => import("@/components/Subscription/SignUp.vue"),
    ),
    "sing-up-offers": defineAsyncComponent(
      () => import("@/components/Offers/SignUp.vue"),
    ),
    "sing-up-certificate": defineAsyncComponent(
      () => import("@/components/Certificates/SignUp.vue"),
    ),
  },
  data() {
    return {
      signUpSubscription: {
        show: false,
        subType: ""
      },

      signUpCertificate: {
        show: false,
        certType: ""
      },
      signUpOffers: {
        show: false,
        offType: ""
      },
      signMain: false,
      signMainData: {
        title: "",
      }
    };
  },
  methods: {
    onNavClick(id: string) {
      const el = document.getElementById(`scroll-${id}`) as HTMLElement;
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    },
  },
  computed: {},
});
</script>

<style scoped lang="less">
#main-page {
  width: 100%;
  height: 100vh;

  .main-root {
    display: flex;
    flex-direction: column;
    margin-top: 100px;

    @max-leve-1-image-height: 920px;

    .main-root__item {
      margin-bottom: 151px;
      scroll-margin-top: 260px;
    }

    @media (max-width: 800px) {
      .main-root__item {
        margin-bottom: unset;
      }
      .level_1 {
        img {
          width: 100%;
          height: calc(@max-leve-1-image-height / 4);
        }
      }
    }

    @media (min-width: 800px) {
      .level_1 {
        img {
          width: 100%;
          max-height: @max-leve-1-image-height;
        }
      }
    }

    .level_3 {
      scroll-margin-top: 150px;
    }

    .level_4 {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .level_5 {
      display: flex;
      justify-content: center;
      align-items: center;
      @media (max-width: 800px) {
        margin-top: 50px;
      }
      @media (min-width: 800px) {
        margin-top: 150px;
      }
      img {
        width: 100%;
      }
    }

    .contact_info {
      margin-bottom: unset;
    }
  }
}
</style>
